module.exports = __webpack_public_path__ + "static/media/swapHorizontalCircle.194b19df.png";